import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { TRACKS } from '../../data/catalog';
import { TrackCard } from './TrackCard';
import { useThemeContext } from '../../context/ThemeContext';

export const CourseCatalog = ({ searchQuery, setSearchQuery }) => {
    const { mode } = useThemeContext();
    const isLight = mode === 'light';

    const filteredTracks = Object.entries(TRACKS).filter(([key, track]) => {
        if (key === 'completeInterviewKit') return false;
        const q = searchQuery.toLowerCase();
        return !q || track.title.toLowerCase().includes(q) || track.description.toLowerCase().includes(q);
    });

    return (
        <Box sx={{ width: '100%', mb: 8 }}>
            {/* Catalog Anchor */}
            <Box id="catalog-section" sx={{ pt: 4, mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: isLight ? '2px solid #e2e8f0' : '2px solid #27272a', pb: 2 }}>
                <Typography variant="h4" fontWeight="800" sx={{ color: isLight ? '#0f172a' : '#f8fafc' }}>
                    Course Catalog
                </Typography>
            </Box>

            {/* Tracks Container */}
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
                gap: { xs: 4, xl: 10 },
                width: '100%'
            }}>
                {filteredTracks.map(([id, track]) => (
                    <TrackCard key={id} id={id} track={track} isLight={isLight} />
                ))}
            </Box>

            {filteredTracks.length === 0 && (
                <Box sx={{ textAlign: 'center', py: 10, width: '100%' }}>
                    <AccountTreeIcon sx={{ fontSize: 60, color: 'var(--text-secondary)', opacity: 0.2, mb: 2 }} />
                    <Typography variant="h5" fontWeight="800" sx={{ color: 'var(--text-primary)', mb: 1 }}>
                        No tracks found for "{searchQuery}"
                    </Typography>
                    <Button variant="text" onClick={() => setSearchQuery('')} sx={{ fontWeight: 700, mt: 1 }}>
                        Reset Search
                    </Button>
                </Box>
            )}
        </Box>
    );
};
